import { CATEGORY } from "../../../components/PrizeLocator/utils/getFiltersBaseOnFlotiqResponse";
const checkStoreBySelectedFilters = (store, selectedFilters) => {
    if (selectedFilters?.length === 0) {
        return true;
    }
    return selectedFilters.some(({ categoryKey }) => store[CATEGORY]?.find((filter) => filter.key === categoryKey));
};
export const getStoresFilteredBySelectedFilters = (stores, selectedFilters) => stores.filter((store) => checkStoreBySelectedFilters(store, selectedFilters));
//# sourceMappingURL=getStoresFilteredBySelectedFilters.js.map